export default __webpack_public_path__ + "static/media/ph01.e038d859.png";